module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-3.2624d76f.png";